/*
 * MDB shim for MDBTabContent
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/InventoryProduct/inventoryProductView.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueView.jsx
 * - src/Seating/Reports/dailyOrderCounts.jsx
 * - src/Seating/Tasks/Tasks.jsx
 */

import { createContext } from "react";
import MUIBox from "@mui/material/Box";

export const MDBTabContext = createContext(null);

export default function MDBTabContent({ children, activeItem, ...rest }) {
    return (
        <MDBTabContext.Provider value={activeItem}>
            <MUIBox {...rest}>{children}</MUIBox>
        </MDBTabContext.Provider>
    );
}
